import React, { Component }  from "react";
import FileViewer from "react-file-viewer";
import {message} from "antd";
import {Unsuppor} from "../../experimentResources/Unsuppor";
import {getHostAddress,getFrontEndAddress,getFileAddress} from "../../../Tool/UtileFun"

//在accountManagement/UserLayout中调用了
export function FileViewerTool(props){
    let file = "http://"+getFrontEndAddress()+props.relativeAddress
    let type = props.fileType

    console.log("chachahssss")
    console.log(file)
    console.log(type)

    //onError={message.error("cuowu")}
    return(
        <FileViewer
            fileType={props.fileType}
            filePath={"http://"+getFrontEndAddress()+props.relativeAddress}
            />
        //<iframe src={`http://view.officeapps.live.com/op/view.aspx?src=${file}`} width='100%' height="700" frameBorder='1'></iframe>
    );

}
